<mat-accordion>
  <mat-expansion-panel [expanded]="openState" (opened)="emitpanelOpenState()" (closed)="emitData()"
    (mouseleave)="closeMe()">
    <mat-expansion-panel-header>
      <mat-panel-title> {{this.selection.selected.length>0 ? 'Selected Services :' + this.selection.selected.length :
        'Select Services' }} </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field >
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search By Service Name.." #input />
    </mat-form-field>
    <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
      aria-label="Select page of periodic elements"></mat-paginator>
    <mat-table [dataSource]="dataSource">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox [color]="'primary'" (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            {{checkboxLabel()}}
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let row">
          <mat-checkbox [color]="'primary'" (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Position Column -->

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.SERVICE_CODE}} - {{ element.SERVICE_NAME }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></mat-row>
    </mat-table>

  </mat-expansion-panel>
</mat-accordion>